import React, { useState } from 'react';
import { RadioGroup, FormControlLabel, Radio, Box, Stack, Button, Chip } from '@mui/material';
import { useNavigate } from "react-router-dom";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";

export default function MultiClientQuestionnaires({ Get, Vend }) {
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState(null);
  const [showRadioGroup, setShowRadioGroup] = useState(true);
  const [startprq, setstartprq] = useState([]);
  const [getpqid, setpqid] = useState();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);


  const handleClientChange = (event) => {
    setSelectedClient(event.target.value);
  };

  const handleContinueClick = () => {
    // setShowRadioGroup(false);
    // navigate(
    //   "/StartPrequalification?clientSelection="+selectedClient+"&Vendor="+Vend+"&ismulti=true")
    axios
      .post(
        "Prequalification/StartQuestionnaire?clientId=" + selectedClient + "&vendorId=" + Vend + "&isMultiClient=true"
      )
      .then((res) => {
        if (res?.data) {
          setstartprq(res?.data?.data?.templates);
          setpqid(res?.data?.data?.prequalificationId);


          // if(res?.data?.data?.templates){

          const serializedData = JSON.stringify(res?.data?.data?.templates);


          navigate(
            "/TemplatesList?startprq=" + serializedData + "&pqid=" + res?.data?.data?.prequalificationId)
          // } else {
          //   toast.error(res?.data.responseMessage, {
          //     position: "top-right",
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     theme: "light",
          //   });
          // }
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      });

  };

  const handleBackClick = () => {
    setShowRadioGroup(true);
  };

  const handleStartPrequalificationClick = () => {
    // Handle the "Start Prequalification" click here
    // You can add your desired logic for this action
  };
  const handleCancleclick = () => {
    // Redirect to "/ClientSelect" when the button is clicked

    navigate(
      "/DashBoard")
  };
  return (
    <>
      <Box sx={{ overflowX: "auto" }}>
        <RadioGroup name="client" value={selectedClient} onChange={handleClientChange}>
          <h2 hidden={Get?.filter((client) => client.isERI === true).length != 0}>No Clients available</h2>
          {Get?.filter((client) => client.isERI === true).map((client, index) => (
            <div key={index}>
              <Stack direction="row" spacing={2}>
                <Stack spacing={0}>
                  <FormControlLabel
                    value={client?.organizationID}
                    control={<Radio />}
                    label={<b style={{ fontSize: "16px" }}>{client?.name}</b>}
                  />
                  <span style={{ color: "#3E4A62", fontSize: "16px", marginBottom: "10px" }}>{"Multi-client format using a common set of insurance and business requirements"}</span>
                  <div>
                    <Stack direction="row" spacing={2} >   {client?.subClients.map((subClient, index) => (<div key={index} ><Chip label={subClient} sx={{ borderRadius: "0", color: "#3E4A62" }} />  </div>
                    ))}</Stack>
                  </div>
                </Stack>
              </Stack>
              <br />
            </div>
          ))}

        </RadioGroup>
       
      </Box>
      <div style={{ marginBottom: "20px" }} hidden={Get?.filter((client) => client.isERI === true).length == 0}>
          <Stack direction="row" spacing={2} style={{ float: "right" }}>
            <Button variant="outlined" sx={{ padding: "15px" }} onClick={handleCancleclick}>Cancel</Button>
            <Button variant="contained" onClick={handleContinueClick} disabled={selectedClient == null}>Continue --{">"}</Button>
          </Stack>
        </div>
    </>
  )
}
